<!--
 * Created by JackCui on 2021/12/1
 -->

<script>
  import {createdSchema, initSchema, insetSchemaNode, beforeCreateSchema, getI18nData, createdEvent} from '../../utils/share'
  import {arrayToObj, projectInfo} from 'fe-coms-share/utils'
  import {requestAllTab} from './request'
  import openEvent from '../mixin/open-event'
  import exportPower from '../../../paas/components/basis/import-export/export-power'
  import staticParams from '../mixin/params'
  import {__changeQuery} from '../../utils/index'
  import {assign} from 'lodash-es'
  import FImport from '../../components/basis/import-export/import-tem.vue'
  import {BUTTON_TYPES} from 'fe-coms-share/paas/constants'


  export default {
    name: 'page-list',
    provide () {
      return {
        formData: this.list,
        store: {
          ...this.store,
          queryParams: this.fetchParams,
          popupConfig: this.popupConfig,
          _tabChange: this._tabChange,
          _search: this._search,
          _changePage: this._changePage,
          scopedSlots: this.scopedSlots
        }
      }
    },
    components: {
      FImport
    },
    mixins: [openEvent, staticParams],
    props: {
      params: Object,
      // 列表数据的总数
      total: Number,

      // 预制对象缓存的搜索条件
      conditionListDefault: {
        type: Object,
        default: () => ({})
      },

      tableData: {
        type: Array,
        default: () => ([])
      },

      // saas配置
      config: {
        type: Object,
        default () {
          return {}
        }
      },
      // 弹窗相关配置
      popupConfig: {
        default: () => ({})
      },
      // 页面权限
      authCode: {
        type: Object,
        default: () => ({})
      },
      menuApiName: {
        type: String,
        default: ''
      },
      // 是否缓存url上列表请求参数
      catchParams: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      fetchParams () {
        return Object.assign(this.queryParams, {
          conditionList: this.conditionList,
          conditionListDefault: this.conditionListDefault
        })
      },
      business () {
        return ({
          'pur': 'TEMPLATE_EXCEL_IMPORT',
          'sur': 'SUPPLIER_TEMPLATE_EXCEL_IMPORT'
        }[projectInfo.query()])
      }
    },
    data () {
      return {
        // 自定义对象
        queryParams: {
          tab: '',
          page: 1,
          pageSize: 10,
          total: this.total
        },
        schema: null,
        // isLoad: false, // 加载完成
        list: [], // 值数据
        store: {
          tenantType: this.params.tenantType,
          objectApiName: this.params.objectApiName,
          layoutApiName: this.params.layoutApiName,
          saveRef: this.saveRef
        },
        refMap: {},
        // 存储当前tab 是否被加载过
        saveTabState: {},
        // 插槽
        scopedSlots: {},
        // 自定义对象
        conditionList: {},
        // isLoadData: false,
        readyState: {
          isSchema: false,
          isData: false
        }
      }
    },
    watch: {
      // table变化设置 list
      tableData (val) {
        this.list.splice(0, this.list.length)
        val.forEach((item, index) => {
          this.$set(this.list, index, item)
        })
        this.readyState.isData = true
        this._provided.store.queryParams.total = this.total
      },
      readyState: {
        deep: true,
        handler ({isData, isSchema}) {
          if (isData && isSchema) {
            this.$nextTick(() => {
              // 页面加载完成回调
              this.$emit('loaded')
            })
          }
        }
      }
    },
    methods: {
      saveRef (name, ref) {
        this.refMap[name] = ref
      },

      // $set更新对象
      _set (object, source) {
        for (let k in source) {
          if (!object[k]) {
            this.$set(object, k, source[k])
          } else {
            object[k] = source[k]
          }
        }
      },

      // 更新tab
      _tabChange (tab) {
        if (tab !== this.queryParams.tab) {
          this.list.splice(0, this.list.length)
          this.$emit('tabChange', tab)
          this.queryParams.tab = tab
          this.queryParams.page = 1
          // todo 清空对象 直接 this.conditionListDefault = {} 会改变引用地址
          for (let key in this.conditionList) {
            delete this.conditionList[key]
          }
          for (let key in this.conditionListDefault) {
            this.conditionListDefault[key] = ''
          }
          this.switchTab()
        }
      },

      // 覆盖 open-eventupdateData 业务数据获取失败调用
      updateData () {
        this.readyState.isData = true
        this._provided.store.queryParams.total = 0
      },

      // 搜索
      _search () {
        this.searchHandle({page: 1})
      },

      // 分页
      _changePage (page) {
        assign(this.queryParams, page)
        // this.list.splice(1, this.list.length)
        this.fetchHandle()
      },

      // 获取默认tab
      getDefaultTab (tabs) {
        return tabs.find(tab => tab.defaultSelected) || tabs[0]
      },

      // 获取全部tabs
      async getAllTab () {
        const params = {
          tenantType: this.tenantType,
          objectApiName: this.objectApiName,
          layoutApiName: this.layoutApiName,
          authCode: this.operationApiName
        }
        const {tabs = [], pageInfoVO = {}} = await requestAllTab(params, this.headerParams)
        await getI18nData(this.objectApiName, pageInfoVO.region)
        // 初始化schema
        this.schema = await initSchema({
          schema: {
            page: {
              layout: {
                elementLinks: [{
                  targetType: 'tabs',
                  elementLinks: tabs,
                  info: pageInfoVO
                }],
                targetType: 'page'
              }
            },
            data: {
              info: pageInfoVO
            },
            objectApiName: this.objectApiName
          }
        }, {config: this.config})
        if (tabs.length > 0) {
          // 获取 url 参数
          this._getUrlParams(tabs)
          if (!this.queryParams.tab) {
            this.queryParams.tab = this.getDefaultTab(tabs).apiName
          }
          this.switchTab()
        }
      },

      // 获取url 参数
      _getUrlParams (tabs) {
        const {c, tab} = this.$route.query
        const findTabItem = tabApiName => tabs.find(v => v.apiName === tabApiName)
        const tabItem = findTabItem(tab)
        // 兼容query.tab
        this.queryParams.tab = tabItem?.apiName || ''
        if (c) {
          const _c = JSON.parse(c)
          this.queryParams.page = _c.page
          this.queryParams.pageSize = _c.pageSize
          if (!tab) {
            const tabItem = findTabItem(_c.tab)
            // 兼容query.c.tab
            this.queryParams.tab = tabItem?.apiName || ''
          }
          this._set(this.conditionList, arrayToObj(_c.conditionList))
          this._set(this.conditionListDefault, _c.conditionListDefault)
        }
      },

      // 切换tab
      switchTab () {
        // 缓存tab的schema
        if (!this.saveTabState[this.queryParams.tab]) {
          this.getTabSchema(this.queryParams.tab)
        } else {
          this.fetchHandle()
        }
      },

      getParams (options) {
        const {conditionList, conditionListDefault} = this.fetchParams
        const conditionMap = {}

        // 处理预制对象中的自定义搜索字段
        for (let key in this.conditionList) {
          const {apiName, value} = this.conditionList[key]
          const apiNameList = apiName.split('.')
          let _obj = conditionMap

          apiNameList.forEach((v, i) => {
            if (!_obj[v]) {
              _obj[v] = {}
            }
            if (apiNameList.length - 1 === i) {
              _obj[v] = value
            }
            _obj = _obj[v]
          })
        }

        return {
          ...JSON.parse(this.$route.query?.c || '{}'),
          ...this.fetchParams,
          ...options,
          menuParams: {
            menuApiName: this.params.menuApiName,
            objectApiName: this.objectApiName,
            layoutApiName: this.layoutApiName
          },
          conditionList: Object.values(conditionList).filter(v => {
            if (Array.isArray(v?.value)) {
              return v?.value.some(v => v)
            }
            return v?.value
          }),
          conditionListDefault: assign(conditionListDefault, conditionMap)
        }
      },

      // 获取值
      fetchHandle (options = {}) {
        const params = this.getParams({
          ...options,
          isSearch: !!options?.isSearch
        })
        this.$emit('fetch-data', params)
        this.catchParams && __changeQuery(params)
      },

      // 搜索
      searchHandle (query) {
        assign(this.queryParams, query)
        this.fetchHandle({isSearch: true})
      },

      // 获取tab的schema
      async getTabSchema (tabLayoutApiName) {
        const tabParams = {
          tenantType: this.tenantType,
          objectApiName: this.objectApiName,
          curAuthCode: this.operationApiName,
          listLayoutApiName: this.params.layoutApiName,
          layoutApiName: tabLayoutApiName
        }
        const {schema} = await beforeCreateSchema(tabParams, this.headerParams, this.config)
        // 缓存
        this.saveTabState[tabLayoutApiName] = true
        // 插入到schema位置
        const _item = await createdSchema(schema, {
          config: this.config,
          scopedSlots: this.scopedSlots,
          btnsEvent: createdEvent.call(this, [BUTTON_TYPES.IMPORT, BUTTON_TYPES.EXPORT]) // 需要注册按钮
        })
        insetSchemaNode(
          this.schema._id,
          this.objectApiName,
          tabLayoutApiName,
          [_item]
        )
        this.fetchHandle()
        this.readyState.isSchema = true
      },

      handleImport (buttonItem) {
        this.$refs.importDialog.handleImport(buttonItem)
      },
      handleExport (buttonItem) {
        const params = this.refMap['filter-search'].getFilterQuery()
        exportPower({
          options: params,
          tab: this.queryParams.tab,
          menuApiName: this.menuApiName,
          ...this.requestParams,
          operationApiName: buttonItem.permissionPointApiName || this.operationApiName,
          buttonApiName: buttonItem.apiName
        })
      }, 
      getFilterQuery () {
        return this.refMap['filter-search'].getFilterQuery()
      },
      setQueryParams () {
        this.refMap['filter-search'].setQueryParams()
      },
      // 切换tab页签
      forceTabChange (tabApiName) {
        this._getRef('tabs').forceTabChange(tabApiName)
      }
    },
    render (h) {
      const { readyState: {isSchema, isData}, schema, objectApiName,  operationApiName, layoutApiName, tenantType} = this
      return (
        <div>
          {
            (isSchema && isData) ?  (<render viewContent={schema?.nodes} />) : (<skeleton page='list'></skeleton>)
          }
          <f-import 
            ref="importDialog" 
            objectApiName={objectApiName}
            operationApiName={operationApiName}
            layoutApiName={layoutApiName}
            tenantType={tenantType}/>
        </div>
      )
    },
    created () {
      assign(this.scopedSlots, this.$scopedSlots)
      this.getAllTab()
    }
  }
</script>

<style scoped lang='scss'>
.import-tip {
  color: #636E95;
}
</style>
